var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-40 0h682.67v512H-40z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    transform: "translate(37.5) scale(.94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0c0",
    d: "M-40 0h768v512H-40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69f",
    d: "M-40 0h768v256H-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40 0l382.73 255.67L-40 511.01V0z",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.8 292.07l-30.82-22.18-30.67 22.4 11.407-36.41-30.613-22.48 37.874-.31 11.747-36.3 12 36.216 37.874.048-30.458 22.695 11.66 36.328z",
    fill: "red"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDj);
export default __webpack_public_path__ + "static/media/dj.576c381d7aba47913099446439fd0b86.svg";
export { ForwardRef as ReactComponent };